<template>

	<div class="district-locator container-fluid">
		
        <div class="form-section half">

            <h2 v-if="title">{{ title }}</h2>
            <div class="body" v-html="body"></div>
            <form id="districtLocator" action="" v-if="form">
                <label for="address" class="sr-only">Address</label>
                <input id="address" type="text" :placeholder="form.placeholderText">
                <button id="addressSubmit" type="submit" :style="'background-image:url(' + form.icon + ');'">
                    <span class="sr-only">Submit Address</span>
                </button>
            </form>
            <div id="district-error">There was an error</div>
            <div class="summary sum-all active">
                <h3>Fulton County Districts</h3>
                <p>Fulton County is in the north-central portion of Georgia. As of 2017 estimates, the population was 1,041,423, making it the state's most populous county and its only one with over one million inhabitants.</p>
                <a class="button-primary" href="#">Learn More</a>
            </div>
            <div class="summary sum-1">
                <h3>District 1 <span> - Liz Hausmann</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 1</a>
            </div>
            <div class="summary sum-2">
                <h3>District 2 <span> - Bob Ellis</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 2</a>
            </div>
            <div class="summary sum-3">
                <h3>District 3 <span> - Lee Morris</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 3</a>
            </div>
            <div class="summary sum-4">
                <h3>District 4 <span> - Natalie Hall</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 4</a>
            </div>
            <div class="summary sum-5">
                <h3>District 5 <span> - Marvin S. Arrington Jr.</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 5</a>
            </div>
            <div class="summary sum-6">
                <h3>District 6 <span> - Emma Darnell</span></h3>
                <ul>
                    <li>City 1</li>
                    <li>City 2</li>
                    <li>City 3</li>
                    <li>City 4</li>
                    <li>City 5</li>
                    <li>City 6</li>
                    <li>City 7</li>
                </ul>
                <a class="button-primary" href="#">Learn More District 6</a>
            </div>
            <!--<div style="display: flex; flex-wrap: wrap;">
        <button class="show-district button-primary" data-district="1">Show District 1</button>
        <button class="show-district button-primary" data-district="2">Show District 2</button>
        <button class="show-district button-primary" data-district="3">Show District 3</button>
        <button class="show-district button-primary" data-district="4">Show District 4</button>
        <button class="show-district button-primary" data-district="5">Show District 5</button>
        <button class="show-district button-primary" data-district="6">Show District 6</button>
        <button class="show-district button-primary" data-district="0">Show All</button>
    </div>-->
        </div>
		
		<div class="half">
			<DistrictLocatorMap></DistrictLocatorMap>
		</div>
		
	</div>
	
</template>

<script>
	
	import DistrictLocatorMap from '../DistrictLocator/DistrictLocatorMap.vue';
	
	export default {
		name: 'DistrictLocator',
		
		props: ['title', 'body', 'form', 'summary', 'image'],
		
		components: {
			DistrictLocatorMap
		}
	}
	
</script>